export const SEARCH_INDEX_IDS = {
  COURSE: 'search-courses',
  PATHWAYS: 'search-pathways',
  PROGRAMS: 'search-programs',
  VIDEOS: 'search-videos',
};
